/* 🤖 this file was generated by svg-to-ts */
export const emperorIconPercent: {
  name: 'percent';
  data: string;
} = {
  name: 'percent',
  data: `<svg viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg"><path fill="none" d="M0 0h24v24H0Z"/><g><path d="M7 10.999c2.205 0 4-1.8 4-4 0-2.21-1.795-4-4-4s-4 1.79-4 4c0 2.205 1.795 3.99 4 3.99Zm0-6c1.1 0 2 .89 2 2 0 1.1-.9 1.99-2 1.99 -1.11 0-2-.9-2-2 0-1.11.89-2 2-2Z"/><path d="M17 13c-2.205 0-4 1.79-4 4 0 2.2 1.795 4 4 4 2.2 0 4-1.8 4-4 0-2.21-1.8-4-4-4Zm0 6c-1.11 0-2-.9-2-2 0-1.11.89-2 2-2 1.1 0 2 .89 2 2 0 1.1-.9 2-2 2Z"/><path d="M.68 11H23.3v1.99H.67Z" transform="rotate(-45 12 12) scale(.99999)"/></g></svg>`
};
